import styled from "styled-components";

export const Title = styled.h1`
  font-weight: 600;
  font-size: 36px;
  line-height: 44px;
  margin: 0px 0px 24px;
  text-align: center;
`;
